import { createSystemPrompt } from "@shared/prompt-template"

const ASSISTANT_NAME = import.meta.env.VITE_ASSISTANT_NAME!

export const systemPrompt = createSystemPrompt(ASSISTANT_NAME)

